/* PELUX · Chantier conversion du 14/10 — zone « achat » de la fiche du harnais
   (thème de test « page parfaite », review/cro-2026-10-14/CHARTE.md).
   Achat et offres : bouton d'achat, paiement express, carte du duo et rappel de Noël, carte de Noël, délais de livraison, réassurance.
   Chargé en defer seulement sur la fiche du harnais, après pelux-preuve.js (layout/theme.liquid).
   Custom elements ou délégation sur le document : les blocs re-rendus (variantes, prix) remplacent
   leur DOM à chaque changement de variante.

   Récapitulatif du duo dans la carte de Noël ([data-cro-recap], snippets/pelux-cro-achat-recap.liquid).
   Rendu par le serveur, il est remis à jour à chaque ouverture de la carte (clic sur un rappel
   [data-edition-ouvrir] : pelux-preuve.js, chargé avant, ouvre la carte ; ce script passe juste après) :
     - le kit : la variante cochée sur la fiche, lue dans <variant-selects> (JSON data-selected-variant,
       le même que product-info.js) — le client a pu changer de coloris ou de taille ;
     - le total : prix de cette variante + prix du duo de la laisse (data-prix-laisse, calculé par
       le serveur comme l'offre duo) ;
     - le délai : le texte de la ligne « Livré entre le … et le … » de la promesse d'achat
       (pelux-delivery-estimate, une seule source) ;
     - garde-fou : si l'offre duo de la page (#pelux-duo) n'ajoute pas la même laisse, ou n'existe
       pas, le récapitulatif se masque — jamais un récapitulatif faux.
   Aucun appel réseau, aucun ajout au panier : le bouton de la carte reste celui de pelux-preuve.js. */
(function () {
  'use strict';
  if (window.peluxCroAchat) return;
  window.peluxCroAchat = true;

  /* Décode les entités du format monétaire de la boutique (ex. « &nbsp;€ »). */
  function decoder(texte) {
    var zone = document.createElement('textarea');
    zone.innerHTML = texte || '';
    return zone.value;
  }

  /* Montant en centimes → texte, au format monétaire de la boutique (shop.money_format). Format
     inconnu : null, et le prix rendu par le serveur reste en place. */
  function formater(centimes, modele) {
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(modele || '');
    if (!m || typeof centimes !== 'number' || !isFinite(centimes)) return null;
    var grouper = function (mille, virgule, decimales) {
      var parts = (Math.round(centimes) / 100).toFixed(decimales).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, mille);
      return decimales ? parts[0] + virgule + parts[1] : parts[0];
    };
    // [séparateur des milliers, séparateur décimal, décimales] — formats de Shopify.
    var formats = {
      amount: [',', '.', 2],
      amount_no_decimals: [',', '.', 0],
      amount_with_comma_separator: ['.', ',', 2],
      amount_no_decimals_with_comma_separator: ['.', ',', 0],
      amount_with_space_separator: [' ', ',', 2],
      amount_with_apostrophe_separator: ["'", '.', 2]
    };
    var f = formats[m[1]];
    if (!f) return null;
    return modele.replace(m[0], grouper(f[0], f[1], f[2]));
  }

  function varianteCochee() {
    var source = document.querySelector('.product__info-container variant-selects [data-selected-variant]');
    if (!source) return null;
    try {
      return JSON.parse(source.textContent);
    } catch (e) {
      return null;
    }
  }

  function majRecap(recap) {
    var duo = document.getElementById('pelux-duo');
    if (!duo || String(duo.getAttribute('data-compagnon')) !== String(recap.getAttribute('data-laisse'))) {
      recap.hidden = true;
      return;
    }
    recap.hidden = false;

    var variante = varianteCochee();
    if (variante) {
      var nom = variante.options && variante.options.length ? variante.options.join(', ') : variante.title;
      var cible = recap.querySelector('[data-cro-kit-variante]');
      if (cible && nom) cible.textContent = nom;
      var modele = decoder(recap.getAttribute('data-format'));
      var prixLaisse = parseFloat(recap.getAttribute('data-prix-laisse'));
      var prixKit = typeof variante.price === 'number' ? variante.price : NaN;
      var kit = formater(prixKit, modele);
      var total = formater(prixKit + prixLaisse, modele);
      var champKit = recap.querySelector('[data-cro-kit-prix]');
      var champTotal = recap.querySelector('[data-cro-total]');
      if (kit && total && champKit && champTotal) {
        champKit.textContent = kit;
        champTotal.textContent = total;
      }
    }

    var ligne = recap.querySelector('[data-cro-delai]');
    if (ligne) {
      var source = document.querySelector('.pelux-cro-promesse [data-pelux-delivery] .pelux-delivery__txt');
      var texte = source ? source.textContent.replace(/\s+/g, ' ').trim() : '';
      var champ = ligne.querySelector('[data-cro-delai-texte]');
      if (champ) champ.textContent = texte;
      ligne.hidden = !texte;
    }
  }

  function majTous() {
    var recaps = document.querySelectorAll('[data-cro-recap]');
    for (var i = 0; i < recaps.length; i++) majRecap(recaps[i]);
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    var ouvrir = cible.closest('[data-edition-ouvrir]');
    if (!ouvrir) return;
    var carte = document.getElementById(ouvrir.getAttribute('aria-controls'));
    if (!carte) return;
    var recaps = carte.querySelectorAll('[data-cro-recap]');
    for (var i = 0; i < recaps.length; i++) majRecap(recaps[i]);
  });

  majTous();
})();
